import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import { Router } from '../../../common/libs/i18n';
import LoadingCircle from '../../../common/components/basic/LoadingCircle';
import { css } from 'styled-components';
import { withRouter } from 'next/router';
import withAuth from '../auth/withAuth';
import {
  K_USER_STATUS_REJECTED,
  K_USER_STATUS_PENDING,
  K_USER_STATUS_BANNED
} from '../../shared/constants';

export default function withGuessAuth(WrappedComponent) {
  const Comp = class GuardGuessComponent extends React.Component<any, any> {
    state = {
      redirectTo: undefined
    };

    static getRedirectPath(user, pathname) {
      let redirectTo = undefined;
      if (!isEmpty(user)) {
        redirectTo = '/dashboard';
      }
      if (redirectTo && !isEqual(redirectTo, pathname)) {
        return redirectTo;
      }
      return undefined;
    }

    static async getInitialProps(context) {
      const { res, user, pathname } = context;
      let redirectTo = GuardGuessComponent.getRedirectPath(user, pathname);
      if (redirectTo) {
        if (res) {
          res.writeHead(302, {
            Location: redirectTo
          });
          res.end();
        } else {
          Router.push(redirectTo);
        }
      }
      return (WrappedComponent.getInitialProps && WrappedComponent.getInitialProps(context)) || {};
    }

    static getDerivedStateFromProps(nextProps, prevState) {
      const {
        router: { pathname },
        auth: { user }
      } = nextProps;
      const newRedirectTo = GuardGuessComponent.getRedirectPath(user, pathname);
      if (prevState.redirectTo !== newRedirectTo) {
        Router.replace(newRedirectTo);
        return {
          redirectTo: newRedirectTo
        };
      }
      return null;
    }

    render() {
      if (this.state.redirectTo) {
        return (
          <div
            css={css`
              width: 100vw;
              height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;
            `}
          >
            <LoadingCircle />
          </div>
        );
      }
      return <WrappedComponent {...this.props} />;
    }
  };
  return withAuth(withRouter(Comp));
}
